import { useQuery } from '@apollo/client';
import axios from 'axios';
import { navigate } from 'gatsby';
import React, { FC, useEffect, useState } from 'react';
import { useAsync } from 'react-use';

import DashboardTask from '@ui/molecules/DashboardTask';

import { ApiEndpoints } from '@utils/endpoints';
import { doesNotExist } from '@utils/general';

import { getAuthToken } from '@providers/AuthProvider';

import { HEALTH_HISTORY } from '../Tasks.data';

const HealthHistoryTask: FC<ITaskProps> = ({
	updateTaskStatus,
	heading,
	description,
	image,
	alt,
	loading,
}) => {
	const [done, setDone] = useState<boolean>(false);

	const {
		loading: qualtricsLoading,
		error: qualtricsError,
		value: qualtricsData,
	} = useAsync(async () => {
		const authorizationToken = await getAuthToken();
		const assignSurveyData = await axios.get<{
			distributionLink: { distributionLink: string; surveyStatus: string };
		}>(`${ApiEndpoints.surveys}/assign-survey/INTAKE`, {
			headers: {
				authorizationToken,
			},
			responseType: 'json',
		});

		return assignSurveyData?.data.distributionLink;
	}, []);

	useEffect(() => {
		if (doesNotExist(qualtricsData)) return;

		const newMember = qualtricsData?.surveyStatus === 'NEW';

		setDone(!newMember);
		updateTaskStatus(HEALTH_HISTORY, false, !newMember);
	}, [qualtricsLoading]);

	const onClick = () => {
		if (qualtricsData?.distributionLink && !done) window.open(qualtricsData?.distributionLink);
	};

	return (
		<DashboardTask
			heading={heading}
			description={description}
			image={image}
			alt={alt}
			done={done}
			onClick={onClick}
			loading={loading}
		/>
	);
};

export default HealthHistoryTask;
